import React, { useState, useEffect } from 'react'
import { Button, Modal, Input } from 'semantic-ui-react'
import classplusLogo from "../../../resources/ClassplusLogo.png";
import webBanner from '../../../resources/webBanner.png';
import download from '../../../resources/downloadIcon.png';
import fb from '../../../resources/fb.png';
import telegram from '../../../resources/tgWEB.png'
import wa from '../../../resources/wpWEB.png'
import dots from "../../../resources/dotsWEB.png"
import copy from "../../../resources/copy.png";
import html2canvas from "html2canvas";
import uploadToS3 from "../../../uploadToS3";
import './webview.css'

import fbCTA from "../../../resources/fbCTA.png"

import { female, male } from "../../../utils/tecahersCard/index";


function WebView(props) {
  const { images, datalength } = props;

  const [imgIndex, setImgIndex] = useState()
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [showPreviewModal, setShowPreviewModal] = useState(false)

  const [studentName, setstudentName] = useState()
  const [mobileNumber, setmobileNumber] = useState('')
  const [teachersName, setteachersName] = useState()
  const [friendName, setfriendName] = useState()

  const [uploadImg, setUploadImg] = useState()

  const [imageArrayType, setimageArrayType] = useState()


  const [isDisabled, setisDisabled] = useState(true)

  const [creativeUrl, setCretiveUrl] = useState();


  const [shareUrl, setShareUrl] = useState('');
  const [fbShareLink, setfbShareLink] = useState('');

  useEffect(() => {
    let textShare = `Hi, yaad hai jb hum class mae yeh kiya krte the. 
Meri tarah, tum bhi apni khud ki 
#ClassWaliDosti post bana skte ho ${window.location.href}`


var fbShareLink = `Hi, yaad hai jb hum class mae yeh kiya krte the. 
Meri tarah, tum bhi apni khud ki 
#ClassWaliDosti post bana skte ho`;


    setShareUrl(textShare)
    setfbShareLink(fbShareLink)
  }, [])


  useEffect(() => {
    if (studentName && mobileNumber && teachersName && mobileNumber.length >9) {
      setisDisabled(false)
    }
  }, [studentName, mobileNumber, teachersName])


  useEffect(() => {
    if (showPreviewModal) {
      makeBlobForApi()

     
    }
  }, [showPreviewModal])

  useEffect(() => {
   
        if(creativeUrl){
          handleAddApi()
        }
 

  }, [creativeUrl])

  const handleCardClick = (index, type) => {
    setimageArrayType(type)
    setImgIndex(index);
    setShowCreateModal(true);
  }

  useEffect(() => {
    if (uploadImg) {
      console.log("use effect");
      uploadToS3([uploadImg])
        .then((resp) => setCretiveUrl(resp[0].url))

    }


  }, [uploadImg]);

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);

  const utmSource =  localStorage.getItem('utmSource')

  const utmMedium = localStorage.getItem("utmMedium");
  const utmCampaign = localStorage.getItem("utmCampaign");

  const handleAddApi = async () => {

    let body = {
      teacherName: teachersName,
      studentName: studentName,
      creativeId: imgIndex,
      studentNumber: mobileNumber,
      friendName: friendName,
      creativeUrl: creativeUrl,
      utmSource,
      utmMedium,
      utmCampaign,
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
    await fetch(
      "https://multiverse-api.classplusapp.com/ts/teachersday/add-teacher",
      requestOptions
    ).then((response) => response.json());
  };


  const makeBlobForApi = () => {
    function dataURItoBlob(dataURI) {
      var binary = atob(dataURI.split(",")[1]);
      var array = [];
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
    }
    var container = document.getElementById("preview-modal-left");

    html2canvas(container, { scale: 3, allowTaint: true }).then(async function (canvas) {
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.download = "Poster.png";
      link.href = canvas.toDataURL("image/png");

      var blobData = dataURItoBlob(link.href);
      blobData.name = "abc.png";
      setUploadImg(blobData);


    });
  };



  const makeBlobToShare = () => {
    function dataURItoBlob(dataURI) {
      var binary = atob(dataURI.split(",")[1]);
      var array = [];
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
    }
    var container = document.getElementById("preview-modal-left");

    html2canvas(container, { scale: 3, allowTaint: true }).then(async function (canvas) {
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.download = "Poster.png";
      link.href = canvas.toDataURL("image/png");
      link.target = '_blank';
      link.click();
      // var blobData = dataURItoBlob(link.href);
      // blobData.name = "abc.png";
      // setUploadImg(blobData);


    });
  };


  function copyText() {
    var text = document.getElementById("preview-modal-copyText").innerText;
    var elem = document.createElement("textarea");
    document.body.appendChild(elem);
    elem.value = `${text} - ${window.location.href}`;
    elem.select();
    document.execCommand("copy");
    document.body.removeChild(elem);

    var x = document.getElementById("snackbar-web");
    x.className = "show";
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  }

  const onCreateClick = () => {

    setShowCreateModal(false);
    setShowPreviewModal(true);
  }

  useEffect(() => {
    if (mobileNumber.length > 10) {
      setmobileNumber(mobileNumber.slice(0, 10))
    }
  }, [mobileNumber])

  const imageClass = `${(imageArrayType == "male") ? 'm' : 'f'}${imgIndex + 1}`

  return (
    <>
      <div className="web-navbar">
        <img src={classplusLogo} alt="" height="63px" width="120px" />
      </div>

      <div className="web-banner">
        <img src={webBanner} width="100%" />
        <div className="web-banner-info">
          <div className="web-banner-heading">
            Kaun hai apka class wala dost?
          </div>
          <div className="web-banner-subheading">
            Class me pen fight khelne se lekar, Class ke baad samose khane tak. #ClassWaliDosti hoti hai sabse special. Bataiye kaun hai vo dost jisne banayi aapki class aur bhi special.
          </div>
        </div>
      </div>

      <div className="web-content">
        <div className="web-content-heading">
          Tell us what you and your friend did in class
        </div>
        <div className="web-content-subheading">
          Choose kare ek memory aur batayein kaun hai apka #ClassWaliDosti ka saathi.
        </div>
        <div className="web-content-categoryLabel">Sir wali class ki #ClassWaliDosti</div>
        <div className="web-content-images">
          {male.map((card, index) => (
            <img src={card.coverImg} width="218px" onClick={() => handleCardClick(index, "male")} />
          ))}
        </div>
        <div className="web-content-categoryLabel">Ma'am wali class ki #ClassWaliDosti</div>
        <div className="web-content-images">
          {female.map((card, index) => (
            <img src={card.coverImg} width="218px" onClick={() => handleCardClick(index, "female")} />
          ))}
        </div>

      </div>

      {showCreateModal ? (
        <Modal open={showCreateModal} onClose={() => setShowCreateModal(false)}>
          <Modal.Header>Personalise this memory and create your own image</Modal.Header>
          <Modal.Content style={{ display: "grid", gridTemplateColumns: "0.8fr 1fr" }}>
            <div className="web-modal-left">
              <img src={
                imageArrayType == "male" ?
                  male[imgIndex].firstImg :
                  imageArrayType == "female" ?
                    female[imgIndex].firstImg :
                    ""

              } alt="" height="356px" width="356px" />
            </div>
            <div className="web-modal-right">
              <div className="web-modal-inputlabel">Your Name</div>
              <Input type="string" maxLength="15" value={studentName} onChange={(e) => { setstudentName(e.target.value) }} fluid placeholder="Enter your name here" />

              <div className="web-modal-inputlabel" style={{ marginTop: "24px" }}>Your Mobile Number</div>
              <Input type="number" value={mobileNumber} onChange={(e) => { setmobileNumber(e.target.value) }} fluid placeholder="e.g - 9560393759" />

              <div className="web-modal-inputlabel" style={{ marginTop: "24px" }}>Your Friend’s Name</div>
              <Input type="string" maxLength="15" value={friendName} onChange={(e) => { setfriendName(e.target.value) }} fluid placeholder="Enter your friends name" />

              <div className="web-modal-inputlabel" style={{ marginTop: "24px" }}>In which teacher's class did you create this memory</div>
              <Input type="string" maxLength="15" value={teachersName} onChange={(e) => { setteachersName(e.target.value) }} fluid placeholder={
                imageArrayType == "male" ?
                  "Enter your sir's name" :
                  imageArrayType == "female" ?
                    "Enter your ma'am's name" : ""

              } />
            </div>

          </Modal.Content>
          <Modal.Actions>
            <Button
              primary
              style={{ fontWeight: "500", fontSize: "18px", lineHeight: "24px", padding: "12px 48px", backgroundColor: "#009AE0" }}
              onClick={() => onCreateClick()}
              disabled={isDisabled}
            >
              Create & Preview
            </Button>
          </Modal.Actions>
        </Modal>
      ) : null}

      {showPreviewModal ? (
        <Modal open={showPreviewModal} onClose={() => setShowPreviewModal(false)}>
          <Modal.Header>Personalise this memory and create your own image</Modal.Header>
          <Modal.Content style={{ display: "grid", gridTemplateColumns: "0.8fr 1fr" }}>
            <div className="preview-modal-left" id="preview-modal-left">
              <img src={
                imageArrayType == "male" ?
                  male[imgIndex].secondImg :
                  imageArrayType == "female" ?
                    female[imgIndex].secondImg :
                    ""

              } className={`preview-modal-img img-${imgIndex}`} />

              <div
                className={`imgText web-studentName-display-${imageClass}`}
              >
                {studentName}
              </div>
              <div
                className={`imgText web-studentName-display-${imageClass}-2`}
              >
                {studentName}
              </div>
              <div
                className={`imgText web-teacherName-display-${imageClass}`}
              >
                {teachersName}
              </div>
              <div
                className={`imgText web-friendName-display-${imageClass}`}
              >
                {friendName}
              </div>
            </div>
            <div className="preview-modal-right">
              <div className="preview-modal-heading">
                Aapki #ClassWaliDosti memory is ready!
              </div>
              <div className="preview-modal-subheading">
                Share karien yeh memory abhi apne sabhi doston aur teachers ke saath
              </div>
              <div id="preview-modal-copyBlock">
                <div id="preview-modal-copyText">
                  Hey, yaad hai jb hum class mae yeh kiya krte the. Meri tarah, tum bhi apni khud ki #ClassWaliDosti post banna skte ho
                </div>
                <div id="preview-modal-copyBtn">
                  <img src={copy} id="preview-modal-copyImg"
                    onClick={() => {
                      copyText();
                    }}
                  />
                </div>

              </div>
              <div className="preview-modal-button">
                <div className="preview-modal-download" onClick={() => { makeBlobToShare() }} >
                  <img src={download} height="15px" alt="" style={{ marginRight: "8px" }} />
                  Download
                </div>
                <img src={fbCTA} onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&description=${fbShareLink}`)} id="preview-modal-fbCTA" />


              </div>


              <div className="preview-modal-social">

                <div className="social-icon" onClick={() => window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`)}><img src={wa} alt="" height="24px" /></div>
                <div className="social-icon" onClick={() => window.open(`https://telegram.me/share/url?text=${encodeURIComponent(shareUrl)}`)}><img src={telegram} alt="" height="24px" /></div>
                <div className="social-icon" onClick={() => {
                  copyText();
                }}><img src={dots} alt="" height="24px" /></div>
              </div>
            </div>
          </Modal.Content>
        </Modal>
      ) : null}
      <div id="snackbar-web">Text copied</div>




      {/* {sendToTeacherModal ? (
        <Modal open={sendToTeacherModal} onClose={()=>setSendToTeacherModal(false)} size="mini">
          <Modal.Header>Send To Teacher</Modal.Header>
          <Modal.Content>
            <div className="web-modal-inputlabel">Your Mobile Number</div>
            <Input type="string" value={teacherNumber} onChange={(e)=>{setTeacherNumber(e.target.value)}} fluid placeholder="e.g - 9560393759"/>
            <div className="web-send-teacher">
              <Button primary>Send To Teacher</Button>
            </div>
          </Modal.Content>
        </Modal>
      ):null} */}
    </>
  )
}

export default WebView
